import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
    Button,
    Loader
} from '@jutro/components';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { withValidation, validationPropTypes } from 'gw-portals-validation-react';
// eslint-disable-next-line import/no-unresolved
import config from 'app-config';
import { withViewModelService, ViewModelForm } from 'gw-portals-viewmodel-react';
import { VehicleInfoLookupService } from 'gw-capability-vehicleinfo';
import VehicleImageLookupService from './VehicleImageLookupService';
import metadata from './VehicleInfoLookupComponent.metadata.json5';
import styles from './VehicleInfoLookupComponent.module.scss';
import './VehicleInfoLookupComponent.messages';

class VehicleInfoLookupComponent extends Component {
    /**
     * @memberof gw-capability-address-react.VehicleInfoLookupComponent
     * @prop {Object} propTypes - the props that are passed to this component
     * @prop {function} propTypes.onValueChange - callback when change is made
     * @prop {string} propTypes.path - path to value in the view modal
     * @prop {boolean} propTypes.displayImage - flag for specifying if
     *  image of the vehicle should be displayed
     */
    static propTypes = {
        value: PropTypes.shape({ postalCode: PropTypes.string }),
        path: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        onValueChange: PropTypes.func,
        onValidate: PropTypes.func,
        displayImage: PropTypes.bool,
        displayAllFields: PropTypes.bool,
        layout: PropTypes.oneOf(['normal', 'reversed', 'full', 'indent']),
        labelPosition: PropTypes.oneOf(['left', 'right', 'top']),
        showVinInfoText: PropTypes.bool,
        showOptional: PropTypes.bool,
        authHeader: PropTypes.shape({}).isRequired,
        viewModelService: PropTypes.shape({
            create: PropTypes.func
        }).isRequired,
        policyEffectiveDate : PropTypes.string,
        ...validationPropTypes
    };

    static defaultProps = {
        onValidate: undefined,
        value: undefined,
        onValueChange: undefined,
        displayImage: true,
        displayAllFields: true,
        labelPosition: 'left',
        layout: 'normal',
        showVinInfoText: false,
        showOptional: true
    };

    state = {
        showLoader: false,
        readonlyOverride: false,
        stockPhoto: undefined,
        showFieldsOverride: true,
        showYearMakeModel: true,
        vehicleType: '',
        vehicleInfoLookupMultiResult: []
    };

    componentDidMount() {
        const {
            id,
            onValidate,
            displayAllFields,
            isComponentValid,
            registerComponentValidation,
            value
        } = this.props;

        registerComponentValidation(this.getIsFormValid);

        if (onValidate) {
            onValidate(isComponentValid, id);
        }

        this.setState({ showFieldsOverride: true, showYearMakeModel: value.viccadminPublicID_EY.value !== undefined ? false : true, readonlyOverride: value.existingVehicle_EY.value && value.publicID.value !== undefined ? true : false,  vehicleType: value.vehicleType.value ? value.vehicleType.value.code : '' });
    }

    componentDidUpdate(prevProps) {
        const {
            onValidate,
            id,
            isComponentValid,
            hasValidationChanged,
            value: newVehicleData
        } = this.props;

        const { value: oldVehicleData } = prevProps;
        const isSameVehicle = _.isEqual(newVehicleData.value, oldVehicleData.value);

        if (onValidate && (!isSameVehicle || hasValidationChanged)) {
            onValidate(isComponentValid, id);
        }
    }

    getIsFormValid = () => {
        const { value: vehicleData } = this.props;
        return vehicleData.aspects.subtreeValid && vehicleData.aspects.valid;
    };

    setCarYears = () => {
        const currentYear = new Date().getUTCFullYear();
        const { oldestCarYear } = config.personalAutoConfig;

        // _.range is not inclusive. Need to add -1 to get correct years
        // 1 year advance logic added for DE6025
        const yearRange = _.range(currentYear + 1 , oldestCarYear - 1);

        return yearRange.map(_.toString).map((year) => ({
            code: year,
            name: year
        }));
    };

    handleChange = (value, changedPath) => {
        const { path, onValueChange } = this.props;
        onValueChange(value, `${path}.${changedPath}`);
    };

    autoFillVehicleFromLookup = (veh, vehicleData) => {
        const vehicle = veh;
        vehicle.make.value = vehicleData.make;
        vehicle.model.value = vehicleData.model;
        vehicle.year.value = vehicleData.year;
        // if(vehicleData.rateBy !== undefined){
        //     vehicle.rateBy.value = vehicleData.rateBy;
        // }
        if(vehicleData.viccadminPublicID_EY){
            vehicle.viccadminPublicID_EY.value = vehicleData.viccadminPublicID_EY;
        }
        if(vehicleData.trim_EY){
            vehicle.viccCode.value = vehicleData.trim_EY;
        }
        if(vehicleData.driveTrain_EY){
            vehicle.driveTrain_EY.value = vehicleData.driveTrain_EY;
        }
        if(vehicleData.engineCylinder_EY){
            vehicle.engineCylinders.value = vehicleData.engineCylinder_EY;
        }
        if(vehicleData.fuelType_EY){
            vehicle.vehicleFuelType.value = vehicleData.fuelType_EY;
        }
        if(vehicleData.bodyStyle_EY){
            vehicle.bodyStyle_EY.value = vehicleData.bodyStyle_EY;
        }
        if(vehicleData.bodyType){
            vehicle.bodyType.value = vehicleData.bodyType;
        }
        if(vehicleData.msrpRateGroup_EY){
            vehicle.msrpRateGroup_EY.value = vehicleData.msrpRateGroup_EY;
        }
        if(vehicleData.bodyWeight_EY){
            vehicle.bodyWeightCode.value = vehicleData.bodyWeight_EY;
        }
        if(vehicleData.omiaVin_EY){
            vehicle.omiaVin_EY.value = vehicleData.omiaVin_EY;
        }

        vehicle.isVINFoundInDataSet_EY = vehicleData.vinfoundInDataSet_EY ? vehicleData.vinfoundInDataSet_EY : false
    };

    setBlankValuesOnVehicle = (vehicle) => {
        vehicle.make.value = '';
        vehicle.model.value = '';
        vehicle.year = undefined;
        // if(vehicle.rateBy !== undefined){
        //     vehicle.rateBy.value = undefined;
        // }
        if(vehicle.viccadminPublicID_EY){
            vehicle.viccadminPublicID_EY.value = undefined;
        }
        if(vehicle.viccCode){
            vehicle.viccCode.value = undefined;
        }
        if(vehicle.driveTrain_EY){
            vehicle.driveTrain_EY.value = undefined;
        }
        if(vehicle.engineCylinders){
            vehicle.engineCylinders.value = undefined;
        }
        if(vehicle.vehicleFuelType){
            vehicle.vehicleFuelType.value = undefined;
        }
        if(vehicle.bodyStyle_EY){
            vehicle.bodyStyle_EY.value = undefined;
        }
        if(vehicle.bodyType){
            vehicle.bodyType.value = undefined;
        }
        if(vehicle.msrpRateGroup_EY){
            vehicle.msrpRateGroup_EY.value = undefined;
        }
        if(vehicle.bodyWeightCode){
            vehicle.bodyWeightCode.value = undefined;
        }
        if(vehicle.omiaVin_EY){
            vehicle.omiaVin_EY.value = undefined;
        }        
        if(vehicle.isVINFoundInDataSet_EY !== undefined){
            vehicle.isVINFoundInDataSet_EY.value = undefined;
        }
    };

    searchVehicleByYearMakeModel = async (searchText) => {
        if(searchText.length > 4){
            const { authHeader } = this.props;
            const response = await VehicleInfoLookupService.lookupBasedOnYearMakeModel(
                searchText, authHeader
            );
            return response.map((v, index) => {
                return {
                    id: index,
                    displayName: v.text,
                    value: v.text
                }
            });
        }
        return [];
    }

    onSearchVehicle = async (item) => {
        if(item !== undefined && item !== null) {
            const { 
                value: vehicleData, authHeader, quoteCreationDate, displayAllFields } = this.props;
            const vehicleType = _.get(vehicleData, 'vehicleType.value.code');
            const vehicleInfo = await VehicleInfoLookupService.getVehicleBasedOnYearMakeModel(item.value, vehicleType, quoteCreationDate, authHeader);
            console.log(vehicleInfo);
            if (vehicleInfo.multipleVICCsFound_EY) {
                    this.setState({vehicleInfoLookupMultiResult: vehicleInfo.vehicleInfoLookupMultiResult });
                    this.setState({ showLoader: false });
                    
                } else {
                    const foundVehicle = _.get(vehicleInfo, 'errorCode') === undefined && vehicleInfo && vehicleInfo.make && vehicleInfo.model && vehicleInfo.year;
                    const vehicleMake = _.get(vehicleInfo, 'make', '');
                    const vehicleModel = _.get(vehicleInfo, 'model', '');
                    const vehicleYear = _.get(vehicleInfo, 'year', '');

                    if (vehicleInfo && vehicleInfo.make && vehicleInfo.model && vehicleInfo.year) {
                        if (!displayAllFields) {
                            this.setState({ showFieldsOverride: true });
                        }
                        this.autoFillVehicleFromLookup(vehicleData, vehicleInfo);
                        this.setState({ showYearMakeModel: false });
                        this.handleChange(vehicleMake, 'make');
                    } else {
                        this.setState({ showFieldsOverride: true });
                        this.setState({ showYearMakeModel: true });
                        this.handleChange(vehicleMake, 'make');
                        this.handleChange(vehicleModel, 'model');
                        this.handleChange(vehicleYear, 'year');
                        this.setBlankValuesOnVehicle(vehicleData);
                    }

                    this.setState({ showLoader: false, readonlyOverride: foundVehicle });
                }
        
        }
    }

    selectVehicleRow = (vehicleInfo) => {
        const { value: vehicleData,displayAllFields } = this.props;
        this.setState({vehicleInfoLookupMultiResult: [] });
        const foundVehicle = _.get(vehicleInfo, 'errorCode') === undefined && vehicleInfo && vehicleInfo.make && vehicleInfo.model && vehicleInfo.year;
        const vehicleMake = _.get(vehicleInfo, 'make', '');
        const vehicleModel = _.get(vehicleInfo, 'model', '');
        const vehicleYear = _.get(vehicleInfo, 'year', '');

        if (vehicleInfo && vehicleInfo.make && vehicleInfo.model && vehicleInfo.year) {

            if (!displayAllFields) {
                this.setState({ showFieldsOverride: true });
            }
            this.autoFillVehicleFromLookup(vehicleData, vehicleInfo);
            this.setState({ showYearMakeModel: false });
            this.handleChange(vehicleMake, 'make');
        } else {
            this.setState({ showFieldsOverride: true });
            this.setState({ showYearMakeModel: true });
            this.handleChange(vehicleMake, 'make');
            this.handleChange(vehicleModel, 'model');
            this.handleChange(vehicleYear, 'year');
            this.setBlankValuesOnVehicle(vehicleData);
        }

        this.setState({ showLoader: false, readonlyOverride: foundVehicle });
    };

     getDataTableCell = (item, index, props) => {
         const path = props.path;
          if (path === 'select') {
              return (
                  <Button onClick={ () => { this.selectVehicleRow(item, index) }}
                  > Select </Button>
              )
          }
          const value = item[path];
          return (<div>{value}</div>);

     };

    handleFocus = () => {
        const {setIsVinEditMode} = this.props;
        setIsVinEditMode(true);
    }

    handleBlur = () => {
        const { value: vehicleData, displayAllFields, authHeader, setIsVinEditMode, policyEffectiveDate } = this.props;
        const vinNumber = _.get(vehicleData, 'vin.value');
        const vehicleType = _.get(vehicleData, 'vehicleType.value.code');

        if (vinNumber === undefined) {
            this.setState({ showFieldsOverride: true });

            return;
        }

        this.setState({ showLoader: true });

        VehicleInfoLookupService.lookupVehicleInfoBasedOnVinVehType(vinNumber, vehicleType, policyEffectiveDate, authHeader)
            .then((vehicleInfo) => {

                if (vehicleInfo.multipleVICCsFound_EY) {
                    this.setState({vehicleInfoLookupMultiResult: vehicleInfo.vehicleInfoLookupMultiResult });
                    this.setState({ showLoader: false });
                    
                } else {
                    this.setState({vehicleInfoLookupMultiResult: [] });
                    const foundVehicle = _.get(vehicleInfo, 'errorCode') === undefined && vehicleInfo && vehicleInfo.make && vehicleInfo.model && vehicleInfo.year;
                    const vehicleMake = _.get(vehicleInfo, 'make', '');
                    const vehicleModel = _.get(vehicleInfo, 'model', '');
                    const vehicleYear = _.get(vehicleInfo, 'year', '');

                    let stockPhoto;

                    if (vehicleInfo && vehicleInfo.make && vehicleInfo.model && vehicleInfo.year) {
                        /*stockPhoto = VehicleImageLookupService.lookupPhoto(
                            vehicleYear,
                            vehicleMake,
                            vehicleModel
                        );*/

                        if (!displayAllFields) {
                            this.setState({ showFieldsOverride: true });
                        }
                        this.autoFillVehicleFromLookup(vehicleData, vehicleInfo);
                        this.setState({ showYearMakeModel: false });
                        this.handleChange(vehicleMake, 'make');
                    } else {
                        this.setState({ showFieldsOverride: true });
                        this.setState({ showYearMakeModel: true });
                        this.handleChange(vehicleMake, 'make');
                        this.handleChange(vehicleModel, 'model');
                        this.handleChange(vehicleYear, 'year');
                        this.setBlankValuesOnVehicle(vehicleData);
                    }

                    this.setState({ showLoader: false, readonlyOverride: foundVehicle, stockPhoto });
                }
                setIsVinEditMode(false);
            })
            .catch(() => {
                this.setState({ showLoader: false });
                setIsVinEditMode(false);
            });
    };

    render() {
        const {
            showLoader, readonlyOverride, stockPhoto, showFieldsOverride, showYearMakeModel, vehicleType
        } = this.state;
        const {
            value: vehicleData,
            displayImage,
            layout,
            labelPosition,
            showVinInfoText,
            showOptional,
            isPolicyChange,
            isReplace
        } = this.props;
        if(vehicleData.vehicleType.value && vehicleData.vehicleType.value.code !== vehicleType){
            this.setState({ showFieldsOverride: true, showYearMakeModel: vehicleData.viccadminPublicID_EY.value !== undefined ? false : true, readonlyOverride: vehicleData.existingVehicle_EY.value && vehicleData.publicID.value !== undefined ? true : false,  vehicleType: vehicleData.vehicleType.value ? vehicleData.vehicleType.value.code : '' });
        }

        
        const overrideProps = {
            '@field': {
                layout: layout,
                labelPosition: labelPosition,
                showOptional: false,
                showRequired: true
            },
            vinInfoContainer: {
                visible: showVinInfoText && !showFieldsOverride
            },
            vehicleVin: {
                onBlur: this.handleBlur,
                readOnly: isPolicyChange ? (readonlyOverride && !isReplace) : readonlyOverride,
                onFocus: this.handleFocus
            },
            vehicleMake: {
                readOnly: isPolicyChange ? (readonlyOverride && !isReplace) : readonlyOverride,
                visible: showFieldsOverride
            },
            vehicleModel: {
                readOnly: isPolicyChange ? (readonlyOverride && !isReplace) : readonlyOverride ,
                visible: showFieldsOverride
            },
            vehicleYear: {
                readOnly: isPolicyChange ? (readonlyOverride && !isReplace) : readonlyOverride,
                visible: showFieldsOverride,
                availableValues: this.setCarYears()
            },
            vehicleSearch:{
                isClearable: true,
                onLoadValues: this.searchVehicleByYearMakeModel,
                onValueChange: this.onSearchVehicle,
                visible: showYearMakeModel && !vehicleData.existingVehicle_EY.value,
                readOnly: isPolicyChange && !!!vehicleData.vehicleSubstituted_EY.value
            },
            vinInfoLookupTable: {
                data: this.state.vehicleInfoLookupMultiResult,
                visible: this.state.vehicleInfoLookupMultiResult.length > 0
            }
        };
        const resolvers = {
            resolveValue: this.readValue,
            resolveClassNameMap: styles,
            resolveCallbackMap: {
                getDataTableCell: this.getDataTableCell,
                selectVehicleRow: this.selectVehicleRow
            }
        };
        return (
            <Loader loaded={!showLoader}>
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    model={vehicleData}
                    overrideProps={overrideProps}
                    onValueChange={this.handleChange}
                    classNameMap={resolvers.resolveClassNameMap}
                    callbackMap={resolvers.resolveCallbackMap}
                />
            </Loader>
        );
    }
}

export default withViewModelService(
    withAuthenticationContext(withValidation(VehicleInfoLookupComponent))
);
